import { Statistic, Typography } from 'antd';
import type { CountdownProps } from 'antd/es/statistic/Countdown';
import type { TextProps } from 'antd/es/typography/Text';

import { ZonedDateTime } from '@/infra/adapters/datetime';
import { State } from '@/v1/domain/models';
import { useDevice } from '@/v1/main/views/Provider';

interface Props {
    type?: TextProps['type'];
    onFinish?: CountdownProps['onFinish'];
    value?: ZonedDateTime;
}
const { Text } = Typography;

const { Countdown } = Statistic;

export const CountdownText: React.FC<Props> = ({
    type,
    onFinish,
    value,
}: Props) => {
    const { isMobileMode } = useDevice();

    if (value == null || !value.isValid || !value.isValid()) {
        return <>{!isMobileMode ? State.IGNORED_VAL : ''}</>;
    }

    return (
        <>
            {value === null || !value.isValid || !value.isValid() ? (
                <>{value}</>
            ) : (
                <Text type={type}>
                    <Countdown
                        value={value.unix() * 1000}
                        format="mm:ss"
                        onFinish={onFinish}
                    ></Countdown>
                </Text>
            )}
        </>
    );
};
